// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aZswf","headline":"_1KVWw","content":"_15uye","stories":"_26M_J","collection-name":"_2B4I3"};